import React from 'react';
import {Grid, Row, Col} from '@/grid';
import Container from '@/container';
import {SectionPadding} from '@/section';
import {H2Neutral50, PNeutral50} from '@/typography';
import {withBgGreen900} from '@/hocs/withColors';
import {useTranslations} from 'next-intl';

import CompanyStats from '../../home/trusted-by-thousands/company-stats';

const Green900Section = withBgGreen900(SectionPadding);

const WhoWeHelp = () => {
  const t = useTranslations('about.whoWeHelp');

  return (
    <Green900Section>
      <Container>
        <Grid fluid>
          <Row center="xs">
            <Col xs={12} lg={8}>
              <H2Neutral50>{t('title')}</H2Neutral50>
              <PNeutral50>{t('description')}</PNeutral50>
            </Col>
          </Row>
          <Row center="xs">
            <Col xs={12}>
              <CompanyStats />
            </Col>
          </Row>
        </Grid>
      </Container>
    </Green900Section>
  );
};

export default WhoWeHelp;
